import { httpClient } from "../../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../../utils/ApiEndpoint";

export const getRCSReportByCustomers = async ({ token, data = {} }) => {
  const response = await httpClient(
    "post",
    ApiEndpoint + "reports/rcs/summary-by-customer",
    data,
    token,
  );

  return response.data;
};
